import { Application } from "stimulus";

const application = Application.start();

export default application;
